var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<option value=\"\">Month</option> <option ng-repeat=\"month in months\" value=\"{{ month }}\">{{ month }}</option>";
ngModule.run(["$templateCache",function(c){c.put("formatters/templates/month.html",v1)}]);
module.exports=v1;


/*****************
 ** WEBPACK FOOTER
 ** ./app/components/ct-payments/formatters/templates/month.html
 ** module id = 549
 ** module chunks = 1
 **/